:host {
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
}

::slotted(a) {
    color: currentColor;
    text-decoration: none;
    background: linear-gradient(to bottom, $color-grey-05-light, $color-grey-05-light) right 0 top 3px / 1px
        13px no-repeat;
    padding-right: 9px;
}

::slotted(a:last-child) {
    background: none;
}
